import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class Whirlpool1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.WHIRLPOOL1;
}

export default Whirlpool1PoiTileEntity;
